import comp from "./LockScreen";
export default comp;
